import script from "./DateInputWithLabel.vue?vue&type=script&setup=true&lang=ts"
export * from "./DateInputWithLabel.vue?vue&type=script&setup=true&lang=ts"

import "./DateInputWithLabel.vue?vue&type=style&index=0&id=9c404312&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c404312"]])

export default __exports__